<template>
  <div>
    <div
      class="form-group"
      v-if="prefijo == enumeraciones.etiquetasDeHTML.Select"
    >
      <select
        v-bind:id="idDelInput"
        v-model="idDelModelo"
        @change="cambiarDatos($event)"
        class="form-control"
        v-bind:disabled="banderaRara"
      >
        <option
          v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id"
          :value="tipo.Id"
          >{{ tipo.Nombre }} un departamento</option
        >
        <option
          v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id"
          :value="tipo.Id"
          >{{ enumeraciones.tiposDeSelect.Todos.Nombre }} los
          departamentos</option
        >
        <option
          v-for="Departamento in DepartamentosLocal"
          :key="Departamento.TipoDepartamentoId"
          :value="Departamento.TipoDepartamentoId"
          >{{ Departamento.Nombre }}</option
        >
      </select>
    </div>
  </div>
</template>

<script>
import enumeraciones from "@/../static/js/enumeraciones";
import comun from "@/../static/js/comun";
import api from "@/../static/js/api";
import axios from "axios";

export default {
  data() {
    return {
      enumeraciones,
      DepartamentosLocal: [],
      idDelModelo: null,
      banderaRara: false,
      h: this.hereda
    };
  },
  props: {
    idDelInput: String,
    valorDefinido: Number,
    parametros: Object,
    prefijo: Number,
    tipo: {
      Id: Number,
      Nombre: String
    },
    hereda: {
      type: Number,
      default: null
    }
  },
  mounted() {
    if (this.valorDefinido == undefined || this.valorDefinido == null)
      this.idDelModelo = this.tipo.Id;
    else this.idDelModelo = this.valorDefinido;

    const parametros = {
      llave: this.idDelInput,
      valor: this.idDelModelo
    };
    this.$store.dispatch(
      "A_SIAP_Catalogo_Establecer039TipoDepartamento",
      parametros
    );
  },
  created() {
    this.h == 0 ? (this.h = -1) : false;
    this.banderaRara = this.h != null && this.h == -1;
    this.cargaCatalogoDepartamentos(this.h);
  },
  methods: {
    cargaCatalogoDepartamentos(AreaId) {
      //alert(AreaId)
      let peticion = {
        EsPrueba: this.enumeraciones.EsPrueba,
        AreaId: AreaId
      };
      axios
        .post(api.conexion + api.PJ.catalogos.C039TiposDepartamentos, peticion)
        .then(respuesta => {
          if (respuesta.data.SiHayError) {
            console.error(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            this.DepartamentosLocal = respuesta.data.TiposDepartamento;
          }
        })
        .catch(excepcion => {
          console.error(excepcion);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(this.enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    cambiarDatos(evento) {
      this.idDelModelo = evento.target.value;
      const parametros = {
        llave: this.idDelInput,
        valor: evento.target.value
      };
      this.$store.dispatch(
        "A_SIAP_Catalogo_Establecer039TipoDepartamento",
        parametros
      );
      this.$emit("valorParaElPadre", evento);
      //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/039TiposDepartamento.vue